module.exports = __webpack_public_path__ + "media/images/rank/regular-sm-fb28097ea0449c51d63ec2ad9a8c59fc.svg";